import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import SignUp from "container/Signup/index";
import ExampleRoute from "container/ExampleRoute";
import Login from "container/Login";
import ForgotPassword from "container/ForgotPassword";
import ResetPassword from "container/ResetPassword";
import OTPScreen from "container/OTPScreen";
import { judgeUuid } from "container/MyProfile/Components/constants";
import { BasicDetails } from "container/Judge/BasicDetails";
import { JudgeSignup } from "container/Judge/JudgeSignup";
import SentryTest from "container/SentryTest";

export default function PublicRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/signup" element={<SignUp />} />
        <Route path="/login" element={<Login />} />
        <Route path="/example" element={<ExampleRoute />} />
        <Route path="/forgotpassword" element={<ForgotPassword />} />
        <Route path="/resetpassword" element={<ResetPassword />} />
        <Route path="/otp" element={<OTPScreen />} />
        <Route path="/sentry-test" element={<SentryTest />} />
        <Route path={`${judgeUuid}/signup`} element={<JudgeSignup />} />
        <Route path={`${judgeUuid}/basicDetails`} element={<BasicDetails />} />
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
